export default "__VITE_ASSET__5f828519__"